module.exports = __webpack_public_path__ + "img/img9.c034e2f6.png";